import React from 'react'
import { Tag, TAG_SIZE, TAG_STYLE } from 'transfix-ui'

interface IEnabledTag {
  isEnabled: boolean
}

export const EnabledTag = ({ isEnabled }: IEnabledTag) => {
  const tagStyle = isEnabled ? TAG_STYLE.info : TAG_STYLE.dark
  const tagLabel = isEnabled ? 'Enabled' : 'Disabled'

  return <Tag label={tagLabel} size={TAG_SIZE.small} tagStyle={tagStyle} />
}
